module.exports = __webpack_public_path__ + "static/media/programa_publico_itala_schmelz.3c5047d7.jpg";